'use strict';


/* ========================================================
 * 		jQuery
 *
 * If you need jQuery in a JS file add this to the top of that file:
 * 		var $ = require('jquery');
 * If some JS code MUST have jQuery globally accessible then
 * add the following line inside this file (index.js).
 * 		var $ = window.jQuery = require('jquery');
 ========================================================= */

/* ========================================================
 * 		Requires
 ========================================================= */
// Polyfills
require('./lib/requestAnimationFrame.js');

// Lib
require('@plaudit/jsf-ajax-adapters/dist/jQuery');

// Analytics

// Old pre-GA4 setup
/* var Analytics = require('@plaudit/analytics').Analytics;
Analytics.getInstance({
    mirrorEvents: {
        microsoft: true     // Mirror events reported to GA to Microsoft's analytics (used for MS Ads)
	}
}); */
import './component/Analytics';


/* ========================================================
 * 		Component Setup
 ========================================================= */

import Forms from './component/Forms';
Forms.init();

require('./site/formLightbox.js').init();
require('./site/announcement.js').init();
require('./site/FormMask.js').init();

require('./site/MainMenu.js').init();
// NOTE: this file triggers "Condition always false"
require('./site/Masthead.js').init();
require('./site/ComLoanCalc').init();
// require('./site/Bookmark.js').init();
import bookmarkControllerInit from './site/BookmarkController';
bookmarkControllerInit();
require('./site/partnerCarousel.js').init();
require('./site/AutoSaveMyProfile.js').init();
require('./site/AdminToggleExportInclusion.js').init();
require('./site/AdminViewBookmarks.js').init();
require('./site/EmailSigBuilder.js').init();
require('./site/DynamicForm.js').init();
require('./site/VerificationDocumentUploadAndManagementForm').init();

window.triggerEvent = function (el, type) {
	if ('createEvent' in document) {
		// modern browsers, IE9+
		var e = document.createEvent('HTMLEvents')
		e.initEvent(type, false, true);
		el.dispatchEvent(e);
	} else {
		// IE 8
		var e = document.createEventObject();
		e.eventType = type;
		el.fireEvent('on' + e.eventType, e);
	}
}

import SlickCarousel from './component/SlickCarousel';
SlickCarousel();

var Accordion = require('./component/Accordion.js');
var additionalInformationAccordion = new Accordion();
additionalInformationAccordion.activate();

import CollapsableGroup from './component/CollapsableGroup';
new CollapsableGroup();

import * as stickybits from 'stickybits';
var stickybit = null;
var stickbitsLoader = function() {
	if (stickybit !== null) {
		stickybit.cleanup();
	}
	stickybit = stickybits('.myProfileForm__stickyFooter', {
		useStickyClasses: true,
		verticalPosition: 'bottom'
	});

	// Run method that updates state classes on sticky items
	for (let i = 0; i < stickybit.instances.length; i++) {
		stickybit.manageState(stickybit.instances[i]);
	}
};
stickbitsLoader();
document.addEventListener('jsfAjaxEvent', stickbitsLoader);

require("./site/listingsAccount").init();

import MapController from './component/Map';
MapController();
